import FormProvider from "./FormProvider"
import FormView from "./FormView"

type SignupProps = {
    onSuccess: () => any
    setLoggingIn: (value: boolean) => void
}

const Signup = (props: SignupProps) => (
    <FormProvider {...props}>
        <FormView {...props} />
    </FormProvider>
)

export default Signup
